// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"a2786b85","228":"3332364e"}[chunkId] + ".chunk.css";
};